var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _rect2, _rect3, _path13, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTraining(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.75,56A4.75,4.75,0,1,0,64,60.75,4.7554,4.7554,0,0,0,68.75,56Zm-8,0A3.25,3.25,0,1,1,64,59.25,3.25377,3.25377,0,0,1,60.75,56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.25,67.38525V72h1.5V67.38525A2.59523,2.59523,0,0,1,61.29736,64.75h5.40528A2.59523,2.59523,0,0,1,69.25,67.38525V72h1.5V67.38525A4.09646,4.09646,0,0,0,66.70264,63.25H61.29736A4.09646,4.09646,0,0,0,57.25,67.38525Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48,60.75A4.75,4.75,0,1,0,43.25,56,4.7554,4.7554,0,0,0,48,60.75Zm0-8A3.25,3.25,0,1,1,44.75,56,3.25377,3.25377,0,0,1,48,52.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25,67.38525V72h1.5V67.38525A2.59523,2.59523,0,0,1,45.29736,64.75h5.40528A2.59523,2.59523,0,0,1,53.25,67.38525V72h1.5V67.38525A4.09646,4.09646,0,0,0,50.70264,63.25H45.29736A4.09646,4.09646,0,0,0,41.25,67.38525Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75,56A4.75,4.75,0,1,0,32,60.75,4.7554,4.7554,0,0,0,36.75,56Zm-8,0A3.25,3.25,0,1,1,32,59.25,3.25377,3.25377,0,0,1,28.75,56Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25,67.38525V72h1.5V67.38525A2.59523,2.59523,0,0,1,29.29736,64.75h5.40528A2.59523,2.59523,0,0,1,37.25,67.38525V72h1.5V67.38525A4.09646,4.09646,0,0,0,34.70264,63.25H29.29736A4.09646,4.09646,0,0,0,25.25,67.38525Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25,56A4.75,4.75,0,1,0,16,51.25,4.7554,4.7554,0,0,0,11.25,56Zm8,0A3.25,3.25,0,1,1,16,52.75,3.25377,3.25377,0,0,1,19.25,56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75,67.38525A2.59523,2.59523,0,0,1,13.29736,64.75h5.40528A2.59523,2.59523,0,0,1,21.25,67.38525V72h1.5V67.38525A4.09646,4.09646,0,0,0,18.70264,63.25H13.29736A4.09646,4.09646,0,0,0,9.25,67.38525V72h1.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.75,25A5.75,5.75,0,1,0,51,30.75,5.75671,5.75671,0,0,0,56.75,25Zm-10,0A4.25,4.25,0,1,1,51,29.25,4.25507,4.25507,0,0,1,46.75,25Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.25049,37.62793v8.373h1.5v-8.373a2.99637,2.99637,0,0,1,3.09717-2.877h6.30615a2.99637,2.99637,0,0,1,3.09717,2.877v8.373h1.5v-8.373a4.49628,4.49628,0,0,0-4.59717-4.377H47.84766A4.49628,4.49628,0,0,0,43.25049,37.62793Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,40.75H40v-1.5H12.5a1.75213,1.75213,0,0,1-1.75-1.75v-25a1.75213,1.75213,0,0,1,1.75-1.75h55a1.75213,1.75213,0,0,1,1.75,1.75v25a1.75213,1.75213,0,0,1-1.75,1.75H62v1.5h5.5a3.25377,3.25377,0,0,0,3.25-3.25v-25A3.25377,3.25377,0,0,0,67.5,9.25h-55A3.25377,3.25377,0,0,0,9.25,12.5v25A3.25377,3.25377,0,0,0,12.5,40.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 15.25,
    width: 14,
    height: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75,16a.7502.7502,0,0,0-.75-.75H16a.7502.7502,0,0,0-.75.75v6a.7502.7502,0,0,0,.75.75h6a.7502.7502,0,0,0,.75-.75Zm-1.5,5.25h-4.5v-4.5h4.5Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 19.25,
    width: 10.5,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 27.25,
    width: 14,
    height: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22,27.25H16a.7502.7502,0,0,0-.75.75v6a.7502.7502,0,0,0,.75.75h6a.7502.7502,0,0,0,.75-.75V28A.7502.7502,0,0,0,22,27.25Zm-.75,6h-4.5v-4.5h4.5Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 31.25,
    width: 10.5,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTraining);
export default __webpack_public_path__ + "static/media/icon_training.f6f8ff97641c62b689cec79727d33c53.svg";
export { ForwardRef as ReactComponent };